import React, { useEffect } from 'react';
import {
    DialogActions,
    DialogContent,
    Grid,
    makeStyles
} from 'core/components/library';
import { Filter, StateLine } from 'core/components';
import * as enums from 'core/enums';
import List from 'store/List';

const useStyles = makeStyles(theme => ({
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-star',
        '& > *': {
            marginLeft: theme.spacing(1)
        }
    },
    root: {
        height: '90vh',
        position: 'absolute',
        top: '5vh',
        right: '0vh'
    },
    selector: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        //backgroundColor: theme.palette.background.paper
        boxShadow: theme.shadows[20]
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[20],
        padding: theme.spacing(2, 4, 3)
    }
}));

const getOptions = scopes => {
    let options = [];
    scopes.forEach(scope => {
        if (scope.value === 'Miembro') {
            options = options.concat(enums.statesEntity);
        }
        if (scope.value === 'Produccion') {
            options = options.concat(enums.locksParcel);
        }
    });

    return options;
};

const ChangeLog = props => {
    const { events, entity, id, scopes } = props;
    const classes = useStyles();

    useEffect(() => {
        const api = `estados/${entity.entity}/${id}`;
        events.load(api);

        return events.unload;
    }, []);

    return [
        <DialogActions className={classes.selector}>
            <Grid container spacing={1}>
                <Grid item xs>
                    <Filter
                        title={'Fecha'}
                        type={'text'}
                        onFilter={valor =>
                            events.filter(['fecha'], valor, 'between', 'date')
                        }
                    />
                </Grid>
                <Grid item xs>
                    <Filter
                        title={'Estado'}
                        type={'select'}
                        onFilter={valor =>
                            events.filter(['estado'], valor, 'in', 'text')
                        }
                        options={getOptions(scopes).filter(i => i.value)}
                    />
                </Grid>
                <Grid item xs>
                    <Filter
                        title={'Ambito'}
                        type={'select'}
                        multiple={false}
                        onFilter={valor =>
                            events.filter(['ambito'], valor, 'in', 'text')
                        }
                        value={
                            scopes && scopes.length !== 0
                                ? scopes[0].value
                                : undefined
                        }
                        options={scopes}
                    />
                </Grid>
            </Grid>
        </DialogActions>,
        <DialogContent className={classes.paper}>
            {events.isReady && !events.isInit && (
                <StateLine
                    principal={'estado'}
                    secondary={'motivo'}
                    date={'fecha'}
                    period
                    events={events.list}
                    options={getOptions(scopes)}
                    onClick={(event, index, open) => {}}
                ></StateLine>
            )}
        </DialogContent>
    ];
};

const ChangeLogContainer = List(ChangeLog, 'events', 'lstLogState');

export default ChangeLogContainer;
